import React, { createContext, useContext, useState } from 'react';

// starts as true so the button opens in the top position on first load
const FloatingButtonContext = createContext({
  scrollY: 0,
  setScrollY: () => {},
  isHomeFocused: true,
  setIsHomeFocused: () => {},
  spinFloatingContent: null,
  setSpinFloatingContent: () => {},
});

export const useFloatingButton = () => useContext(FloatingButtonContext);

export function FloatingButtonProvider({ children }) {
  const [scrollY, setScrollY] = useState(0);
  const [isHomeFocused, setIsHomeFocused] = useState(true);
  const [spinFloatingContent, setSpinFloatingContent] = useState(null);

  return (
    <FloatingButtonContext.Provider
      value={{
        scrollY,
        setScrollY,
        isHomeFocused,
        setIsHomeFocused,
        spinFloatingContent,
        setSpinFloatingContent,
      }}
    >
      {children}
    </FloatingButtonContext.Provider>
  );
}
